import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import env from 'Env';
import imgixConfig from 'Config/imgix';
import ShowcaseCarousel from 'Features/Product/components/ShowcaseCarousel/ShowcaseCarousel';

import 'Features/Product/components/ShowcaseGallery/ShowcaseGallery.scss';

export default function ShowcaseGallery({ product }) {
  const slideWidths = {
    xs: 300,
    sm: 500,
    md: 650,
    lg: 750,
    xl: 850,
    xxl: 1130,
  };

  const screenshots = get(product, 'img', []);

  return (
    <div className="ShowcaseGallery">
      <ShowcaseCarousel
        slideWidths={slideWidths}
        title="Gallery"
        appearsOn="gallery"
      >
        {screenshots && screenshots.map((screenshot, i) =>
          <div
            className="ShowcaseGallery__card"
            key={screenshot.slug}
          >
            <img
              srcSet={`
                ${env.cdnUrl}/product/original/${screenshot.slug}?${imgixConfig}&q=75&w=1920&h=1080&fit=crop 1920w,
                ${env.cdnUrl}/product/original/${screenshot.slug}?${imgixConfig}&q=75&w=1440&h=810&fit=crop 1440w,
                ${env.cdnUrl}/product/original/${screenshot.slug}?${imgixConfig}&q=75&w=1280&h=720&fit=crop 1280w,
                ${env.cdnUrl}/product/original/${screenshot.slug}?${imgixConfig}&q=75&w=1130&h=636&fit=crop 1130w,
                ${env.cdnUrl}/product/original/${screenshot.slug}?${imgixConfig}&q=75&w=960&h=540&fit=crop 960w,
                ${env.cdnUrl}/product/original/${screenshot.slug}?${imgixConfig}&q=75&w=740&h=416&fit=crop 740w,
                ${env.cdnUrl}/product/original/${screenshot.slug}?${imgixConfig}&q=75&w=640&h=360&fit=crop 640w,
                ${env.cdnUrl}/product/original/${screenshot.slug}?${imgixConfig}&q=75&w=480&h=270&fit=crop 480w,
                ${env.cdnUrl}/product/original/${screenshot.slug}?${imgixConfig}&q=75&w=384&h=216&fit=crop 384w
              `}
              sizes={`(min-width: 1520px) ${slideWidths.xxl}px, (min-width: 1200px) ${slideWidths.xl}px, (min-width: 992px) ${slideWidths.lg}px, (min-width: 768px) ${slideWidths.md}px, (min-width: 576px) ${slideWidths.sm}px, ${slideWidths.xs}px`}
              src={`${env.cdnUrl}/product/original/${screenshot.slug}?${imgixConfig}&q=75&w=1920&h=1080&fit=crop 1920w`}
              alt={screenshot.alt}
              className="ShowcaseGallery__card__img"
            />
            <div className="ShowcaseGallery__card__count">
              {i + 1} / {screenshots.length}
            </div>
          </div>,
        )}
      </ShowcaseCarousel>
    </div>
  );
}

ShowcaseGallery.propTypes = {
  product: PropTypes.shape(),
};

ShowcaseGallery.defaultProps = {
  product: {},
};
